module.exports = __webpack_public_path__ + "static/img/case1.447d454.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/h5/case1.png
// module id = PVkS
// module chunks = 34